import { AES, enc } from 'crypto-js';

const secret = import.meta.env.VITE_SECRECT_HASH;

export const decryptMessage = (message:string) => {
    let bytes;
    try {
    //   bytes = AES.decrypt(message, secret);
    //   const decrypted = bytes.toString(enc.Utf8);
    //   return decrypted;
    return message;
    } catch (err) {
      return '';
    }
  };

export const encryptMessage =(message:string) =>{
//    return AES.encrypt(message, secret);
    return message;
}

export const storeLocalInfo =(key:string, message:string) =>{
    localStorage.setItem(key, message);
}

export const getLocalInfo =(key:string) =>{
    return localStorage.getItem(key);
 }

 export const deleteLocalInfo =(key:string) =>{
    localStorage.removeItem(key);
}

export const clearLocalInfo =(key:string) =>{
    localStorage.clear();
}